// INTERFACE AND ENUMS
import { FormFieldConfig } from '../../../../../models/common/forms/form-field-config';

// CONSTANTS FOR FORM
import { addressOneControl, addressTwoControl, allowSMSControl, businessColorControl, businessLogoControl, businessName, businessRewardControl, cityControl, countryControl, dateFormatControl, gstIdControl, pincodeControl, shiftTimeEndControl, shiftTimeStartControl, stateControl, timeFormatControl, timeZoneControl, vatIdControl } from '../../../../../constants/form-control/business';

// Utils
import { FormControlUtil } from '../../../../../core/utils/form-control';
import { currencyControl } from '../../../../../constants/form-control/core/address/currency';
import { textboxNumberRequiredControl } from '../../../../../constants/form-control/core/common/textbox/textbox-number-required';
import { labelManage } from '../../../../../constants/form-control/business/label';
import { tooltip } from 'leaflet';

/**
 * This constant used for Business Detail Form
 */
export const BUSINESS_DETAILS_FORM_CONTROLS: FormFieldConfig[] = [{
  row: 1,
  fields: [
    FormControlUtil.mergeFormControl(businessName, { key: 'business_name' }),
  ],
},
{
  row: 2,
  fields: [
    FormControlUtil.mergeFormControl(addressOneControl, { key: 'business_address_1' }),
    FormControlUtil.mergeFormControl(addressTwoControl, { key: 'business_address_2' }),
  ],
},
{
  row: 3,
  fields: [
    FormControlUtil.mergeFormControl(countryControl, { key: 'country' }),
    FormControlUtil.mergeFormControl(stateControl, { key: 'state' }),
  ],
}, {
  row: 4,
  fields: [
    FormControlUtil.mergeFormControl(cityControl, { key: 'business_city_name' }),
    FormControlUtil.mergeFormControl(pincodeControl, { key: 'business_pincode' }),
  ],
}, {
  row: 5,
  fields: [
    FormControlUtil.mergeFormControl(vatIdControl, { key: 'business_vat_id' }),
    FormControlUtil.mergeFormControl(gstIdControl, { key: 'business_gst_id' }),
  ],
}, {
  row: 6,
  fields: [
    FormControlUtil.mergeFormControl(dateFormatControl, { key: 'business_date_format' }),
    FormControlUtil.mergeFormControl(timeFormatControl, { key: 'business_time_format' }),
  ],
}, {
  row: 7,
  fields: [
    FormControlUtil.mergeFormControl(allowSMSControl, { key: 'business_allow_sms' }),
    FormControlUtil.mergeFormControl(textboxNumberRequiredControl, {
      key: 'business_min_shift',
      templateOptions: FormControlUtil.mergeFormControl(textboxNumberRequiredControl.templateOptions, { label: 'Min Shift Length(Min)' }),
    }),
    FormControlUtil.mergeFormControl(timeZoneControl, { key: 'timezone' }),
    FormControlUtil.mergeFormControl(currencyControl, { key: 'business_fk_currency_id' }),

  ],
}];


export const BUSINESS_DETAIL_LABEL_FORM : FormFieldConfig[] = [
  {
    row: 1,
    fields: [
      FormControlUtil.mergeFormControl(labelManage, { key: 'client' }),
      FormControlUtil.mergeFormControl(labelManage, { key: 'location' ,  templateOptions: FormControlUtil.mergeFormControl(textboxNumberRequiredControl.templateOptions, { label: 'Location' , placeholder : 'Location', tooltip :`Change 'Location' to fit your business, like 'Office', 'Branch', or any preferred term.` ,    tooltipPosition:'right',
      }),}),

    ],
  },
  {
    row: 2,
    fields: [
      FormControlUtil.mergeFormControl(labelManage, { key: 'area'  , templateOptions: FormControlUtil.mergeFormControl(textboxNumberRequiredControl.templateOptions, { label: 'Area ' , placeholder : 'Area' , tooltip:`Change 'Area' to fit your business, like 'Zone', 'Department', or any preferred term.` ,    tooltipPosition:'right',
      }),}),
      FormControlUtil.mergeFormControl(labelManage, { key: 'contractor' , templateOptions: FormControlUtil.mergeFormControl(textboxNumberRequiredControl.templateOptions, { label: 'Contractor' , placeholder : 'Contractor' , tooltip:`Change 'Contractor' to fit your business, like 'Vendor', 'Supplier', or any preferred term.` ,    tooltipPosition:'right',
      }),}),
    ],
  },
];



/**
 * This constant used for Business Rewards Form
 */
export const BUSINESS_REWARDS_FORM_CONTROLS: FormFieldConfig[] = [
  {
    row: 1,
    fields: [
      FormControlUtil.mergeFormControl(businessRewardControl, { key: 'business_reward_point' }),
    ],
  },
  {
    row: 2,
    fields: [
      FormControlUtil.mergeFormControl(shiftTimeStartControl, { key: 'business_reward_buffer_time_start_shift' }),
      FormControlUtil.mergeFormControl(shiftTimeEndControl, { key: 'business_reward_buffer_time_end_shift' }),
    ],
  },
];

/**
 * This constant used for Business Branding Form
 */
export const BUSINESS_BRANDING_FORM_CONTROLS: FormFieldConfig[] = [{
  row: 1,
  fields: [
    FormControlUtil.mergeFormControl(businessLogoControl, { key: 'business_logo' }),
  ],
},
  {
    row: 2,
    fields: [
      FormControlUtil.mergeFormControl(businessColorControl, { key: 'business_color' }),
    ],
  }
];

/**
 * This constant used for all form navigation
 */
export const FORM_CONSTANTS = {
  'BRAND_FORM': 'businessBrandingForm',
  'DETAIL_FORM': 'businessDetailForm',
  'DETAIL_LABEL_FORM' : 'businessDetailLabelForm',
  'REWARD_FORM': 'businessRewardForm',
  'PLAN_FORM': 'businessPlanForm'
}


/**
 * This constant used for all form navigation
 */
export const FORM_NESTED_FIELDS = {
  'country': { 'country_id': 'business_fk_country_id', 'country_name': 'business_fk_country_name' },
  'state': { 'state_id': 'business_fk_state_id', 'state_name': 'business_fk_state_name' },
  'timezone': { 'timezone_id': 'business_fk_timezone_id', 'timezone_name': 'business_fk_timezone_name' },
}
